<template lang="pug">
footer#bh-footer.bh-footer(v-if="displayFooter")
  .container
    .row
      .col-md-4.clearfix
        .pull-left.logo-block
          img(src="~assets/footer_logo.png")
      .col-md-4
        .text-center
          ul.style-none
            router-link.pointer(tag="li", :to="{ name: 'aboutUs' }") About
            router-link.pointer(tag="li", :to="{ name: 'privacy' }") Privacy
            //- router-link.pointer(tag="li", :to="{ name: 'contactUs' }") Contact
      .col-md-4.clearfix
        .pull-right.copyright-block
          p.copyright &copy; Copyright {{ year }}. All Rights Reserved.
</template>

<script>

export default {
  props: {
    displayFooter: {
      type: Boolean,
      default: true
    }
  },
  data () {
    var d = new Date()
    var year = d.getFullYear()
    return {
      footerMsg: 'This is Footer',
      year: year
    }
  }
}
</script>


<style lang="sass">
@import '../variables'
@include sticky-footer(102px,"#layout","#layout_footer","#bh-footer")

footer#bh-footer
  height: 102px
  width: 100%
  background-color: $black-3
  padding: 20px
  border-top: 1px solid $border
  color: $white
  ul
    margin-top: 20px
    li
      font-size: 16px
      display: inline-block
      &::after
        content: '|'
        display: inline-block
        margin: 0 30px 0 30px
        height: 16px
        width: 1px
      &:last-child
        &::after
          display: none
  p.copyright
    font-size: 16px
    margin-top: 20px
  @media screen and (max-width: $breakpoint-sm)
    height: initial
    .logo-block, .copyright-block
      float: inherit !important
      text-align: center
</style>



// WEBPACK FOOTER //
// src/components/bhFooter.vue